import React, { useState, useEffect, createContext } from 'react';
import Audio from './audio/audio';
import QuestionPallete from './right-side/question-palette';
import SectionCollections from './left-side/sections/section-collection';
// import SubmitLoader from '../common/submit';
import { useDispatch, useSelector } from 'react-redux';
import { addData, setData } from '../../../actions/auth';
import { notification, Skeleton, Modal } from 'antd';
import PreShowLock from '../common/pre-show';
import { setMockTestEditData, updateMockTestRequest } from '@/actions/mock-test';
import useWidth from '@/helpers/widthUtil';
import { isDateFuture } from '@/helpers/dateHelper';
import { Counter } from './countdown/counter';
import { isLogin } from '@/helpers/loginHelper';
import Onboarding from '@/components/landing/onboarding';

const MockTestListeningComponentCollection = (props) => {
  const dispatch = useDispatch();
  const [paletteUp, setPaletteUp] = useState(false);
  const [audioTime, setAudioTime] = useState('');
  const [answers, setAnswer] = useState({});
  const [scrollToQ, setScrollTo] = useState(1);
  const [ans, setAns] = useState([]);
  const [newAns, setNewAns] = useState([]);
  const [newSection, setSection] = useState(props?.data?.data?.section);
  const [mulQ, setMulQ] = useState([]);
  const [testStarted, setTestStarted] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [timeFinished, setTimeFinished] = useState(false);
  const [count, setCount] = useState(0);
  const [examCountdown, setExamCountdown] = useState(false);

  const {
    loginModal,
    testTimeFinished,
    listening,
    answeredList,
    submitMockTestStatus,
  } = useSelector((state: any) => ({
    loginModal: state.auth.helperObj?.loginModal,
    testTimeFinished: state.MockTestReducer?.test?.finished,
    listening: state.MockTestReducer?.listening?.submit,
    answeredList: state?.MockTestReducer?.answeredList,
    submitMockTestStatus: state?.MockTestReducer?.submitMockTestStatus,
  }));
  const { isMobile } = useWidth();
  const testType = props.data?.data?.test_type;

  useEffect(() => {
    typeof window !== 'undefined' &&
      window?.$crisp &&
      window?.$crisp?.push(['do', 'chat:hide']);
    clearState();
    !isLogin() &&
      dispatch(setData({ name: 'helperObj', key: 'loginModal', value: true }));
  }, []);

  useEffect(() => {
    if (props?.data?.data?.exam_date) {
      const exam_date = props?.data?.data?.exam_date;
      if (isDateFuture(exam_date)) {
        setExamCountdown(true);
        !isLogin() &&
          dispatch(setData({ name: 'helperObj', key: 'loginModal', value: true }));
      } else {
        setExamCountdown(false);
      }
    }
  }, [props?.data]);

  if (typeof window !== 'undefined') {
    let elementId = document.getElementById('mock-test__right-page');
    const scrollto = window.addEventListener('scroll', () => {
      if (typeof window !== undefined) {
        if (window.scrollY > 170 && !isMobile) {
          elementId?.classList.add('question-margin');
        } else {
          elementId?.classList.remove('question-margin');
        }
      }
    });
  }

  useEffect(() => {
    if (testTimeFinished) {
      setTimeFinished(true);
    }
    clearState();
  }, [testTimeFinished]);

  useEffect(() => {
    if (timeFinished) {
      notification.info({ message: 'Time Is Up' });
      submit();
      setTimeout(() => {
        setShowLoader(true);
      }, 2000);
    }
  }, [timeFinished]);

  // useEffect(() => {
  //     setTimeout(() => {
  //         if (listening?.success) {
  //             window.location.pathname = '/mock-test/reports';
  //         }
  //     }, 2500)
  // }, [listening?.success])

  useEffect(() => {
    if (listening?.loading) {
      setShowLoader(true);
    } else {
      setTimeout(() => {
        setShowLoader(false);
      }, 2000);
    }
  }, [listening?.loading]);

  const clearState = () => {
    dispatch(addData({ key: 'test', value: {} }));
    dispatch(setData({ name: 'test', key: 'finished', value: false }));
    dispatch(addData({ key: 'listening', value: {} }));
    dispatch(setData({ name: 'listening', key: 'loading', value: false }));
    dispatch(setData({ name: 'listening', key: 'success', value: true }));
    dispatch(setMockTestEditData({ key: 'answeredList', value: [] }));
  };

  const toggleQuestionView = () => {
    setPaletteUp(!paletteUp);
  };

  const listenFrom = (time) => {
    setAudioTime(time);
  };

  const scrollIntoQuestion = (num) => {
    setScrollTo(num);
  };

  const refs = React.useRef([]);

  useEffect(() => {
    refs.current[scrollToQ]?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }, [scrollToQ]);

  useEffect(() => {
    if (props?.success) {
      var section = props?.data?.data?.section;
      var section_no = 1;
      section?.forEach((s) => {
        s.section_no = section_no;
        var from = s.question_from ? s.question_from : 1;
        var to = s.question_to;
        var q_no = from;
        s.question.forEach((q) => {
          q.q_no = q_no;
          if (q.question_type == 1) {
            q_no = q_no + q.no_answer;
          } else {
            q_no = q_no + 1;
          }
          if (q.question_type != 3)
            setAns((prevans) => [
              ...prevans,
              { section_id: s?.id, model_id: props?.data?.id, question_id: q?.id },
            ]);
          if (q.question_type == 1) {
            setMulQ((mulQ) => [
              ...mulQ,
              {
                q_no: q_no - q.no_answer,
                from: q_no - q.no_answer,
                to: q_no - 1,
                type: 1,
              },
            ]);
          } else {
            setMulQ((mulQ) => [
              ...mulQ,
              {
                q_no: q_no - q.no_answer,
                from: q_no - q.no_answer,
                to: q_no - 1,
                type: q.question_type,
              },
            ]);
          }
        });
        section_no = section_no + 1;
      });
      setSection(section);
    }
  }, [props?.success]);

  useEffect(() => {
    setNewAns(ans);
  }, [ans]);

  useEffect(() => {
    //disable scrolling page until user starts the test
    !testStarted
      ? (document.body.style.overflow = 'hidden')
      : (document.body.style.overflow = 'scroll');

    return () => {
      document.body.style.overflow = 'scroll';
    };
  }, [testStarted]);

  useEffect(() => {
    if (submitMockTestStatus === 'success') {
      window.location.pathname = `/mock-test/reports/${props.data?.data?.slug}`;
      dispatch(setMockTestEditData({ key: 'submitMockTestStatus', value: '' }));
    }
  }, [submitMockTestStatus]);

  const getCount = (count) => {
    setCount(count);
  };

  const submit = async () => {
    dispatch(
      updateMockTestRequest({
        mockTestSlug: props.data?.data?.slug,
        data: {
          time_taken: count,
          ...(testType === 'NORMAL' && { all_answer: answeredList }),
        },
      })
    );
    // window.location.pathname = `/mock-test/reports/${props.data?.data?.slug}`;
  };

  const ModalLoginOpen = () => {
    dispatch(
      setData({
        name: 'helperObj',
        key: 'loginModal',
        value: !loginModal,
      })
    );
  };

  const handleTestStarted = () => {
    if (!isLogin()) {
      dispatch(setData({ name: 'helperObj', key: 'loginModal', value: true }));
    } else {
      setTestStarted(true);
    }
  };
  return (
    <MockTestContext.Provider value={{ submit, testType }}>
      <Modal
        visible={loginModal}
        // handleClick={handleAdd}
        // onCancel={() => ModalLoginOpen()}
        // buttonLabel1="Add"
        footer={[]}
        maskClosable={false}
        closable={false}
      >
        <div className="banner-form">
          <Onboarding is_instructor={false} isLoginPage={true} />
        </div>
      </Modal>
      <div
        className={`d-flex custom-container ${loginModal ? 'blur-background' : ''}`}
      >
        {/* {
                showLoader &&
                <SubmitLoader />
            } */}
        {props?.loading || props?.data?.is_enroll === false ? (
          <>
            <div className={`mock-test__left-page col-lg-8`}>
              <Skeleton.Input />
              <Skeleton />
              <Skeleton />
              <Skeleton />
              <Skeleton />
              <Skeleton />
            </div>
            <div
              className={'mock-test__right-page p-2'}
              style={{ background: '#f0f2f5' }}
            >
              {[...Array(40)].map((x, i) => {
                return (
                  <a key={i}>
                    <Skeleton.Button className="p-1 m-1" shape="round" />
                  </a>
                );
              })}
            </div>
          </>
        ) : examCountdown ? (
          <div
            className="mx-auto text-center d-flex flex-column justify-content-center align-items-center"
            style={{ height: '80vh' }}
          >
            <img src="/images/svgs/test-countdown.svg" width="600" />
            {isLogin() ? (
              <>
                <h1 className="mt-4">MOCK TEST BEGINS IN</h1>
                <Counter
                  date={props?.data?.data?.exam_date}
                  countdownComplete={() => setExamCountdown(false)}
                />
              </>
            ) : (
              <h1 className="mt-4">PLEASE LOGIN TO GIVE MOCK TEST</h1>
            )}
          </div>
        ) : (
          <>
            <PreShowLock
              testStarted={testStarted}
              setTestStarted={setTestStarted}
              testData={props?.data?.data}
            />
            <div
              className={` ${
                !testStarted ? 'disable-content' : ''
              } mock-test__left-page`}
            >
              <h2 className="text-center mt-4 ">{props?.data?.data?.title}</h2>
              {props?.audio && (
                <Audio testStarted={testStarted} audio={props?.data?.data} />
              )}

              <SectionCollections
                listenFromHere={listenFrom}
                section={newSection}
                data={props.data}
                scrollToQn={scrollToQ}
                answers={newAns}
                setAns={setAns}
                setAnswer={setAnswer}
                testStarted={testStarted}
                count={count}
              />
            </div>
            <div
              className={
                paletteUp
                  ? 'mock-test__right-page mr-2 palette_up '
                  : 'mock-test__right-page mr-2 pt-5'
              }
              id="mock-test__right-page"
            >
              <QuestionPallete
                data={props.data}
                testStarted={testStarted}
                setTestStarted={handleTestStarted}
                toggleQuestionView={toggleQuestionView}
                mulQ={mulQ}
                answers={answers}
                newAns={newAns}
                scrollIntoQuestionNum={scrollIntoQuestion}
                passCount={getCount}
                paletteUp={paletteUp}
              />
            </div>
          </>
        )}
      </div>
      {/* <Row>
        {testStarted ? (
          <div className="text-center mb-1 mt-0 mx-auto mock-test-submit-btn">
            <Button className="btn-secondary border-0" onClick={submit}>
              Submit
            </Button>
          </div>
        ) : (
          <div className="text-center mt-auto">
            <Button
              className="btn-secondary border-danger"
              onClick={() => setTestStarted(true)}
            >
              Start Test
            </Button>
          </div>
        )}
      </Row> */}
    </MockTestContext.Provider>
  );
};

export default MockTestListeningComponentCollection;

export const MockTestContext = createContext<any>({});
